import { render } from "./ContextMessage.vue?vue&type=template&id=2d9b38e4&scoped=true"
import script from "./ContextMessage.vue?vue&type=script&lang=js"
export * from "./ContextMessage.vue?vue&type=script&lang=js"

import "./ContextMessage.vue?vue&type=style&index=0&id=2d9b38e4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9b38e4"]])

export default __exports__